import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { EeocFormData, LookupFieldData, Person } from '../../typings';

@Injectable({ providedIn: 'root' })
export class EeocApiService {
  constructor(private apiService: ApiService) {}

  getEeocLookupFields(talentId: number): Observable<Map<string, LookupFieldData[]>> {
    return this.apiService.httpWrapper<Map<string, LookupFieldData[]>>({
      method: 'GET',
      url: `/api/eeoc/lookupFields/${talentId}`
    });
  }

  submitEeocData(request: EeocFormData): Observable<EeocFormData> {
    return this.apiService.httpWrapper<EeocFormData>({
      method: 'POST',
      url: `/api/eeoc/`,
      body: JSON.stringify(request),
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json'
      })
    });
  }

  readEeocData(talentId: number): Observable<EeocFormData> {
    return this.apiService.httpWrapper<EeocFormData>({
      method: 'GET',
      url: `/api/eeoc/read/${talentId}`,
      authenticated: true,
      withCredentials: true
    });
  }

  getPersonByEeocUuid(uuid: string): Observable<Person> {
    const params = new HttpParams();
    return this.apiService.httpWrapper<Person>({
      method: 'GET',
      url: `/api/eeoc/${uuid}`,
      authenticated: true,
      params
    });
  }
}
